import { dateFilter } from '@/utils/filters'
import dayjs from 'dayjs'
import axios from 'axios'

const actions = {
  resetPageFilter ({ commit }) {
    const pageFilter = {
      dateRange: [
        dateFilter(dayjs().subtract(7, 'day'), 'base'),
        dateFilter(dayjs(), 'base')
      ],
      name: '',
      email: '',
      phone: '',
      cpf: '',
      action: '',
      plugin: '',
      product: '',
      status: '',
      csat: [],
      feeling: []
    }

    commit('SET_PAGE_FILTER', pageFilter)
  },

  async fetchPlatformActions ({ commit, state, rootGetters }) {
    if (state.platformActions?.length) {
      return
    }

    try {
      const { 'auth/platformId': platformId } = rootGetters
      const url = `${state.mainApi}auth/action/platform/${platformId}`
      const response = await axios.get(url)

      const data = response.data.sort((a: any, b: any) => a.description.localeCompare(b.description))

      commit('SET_PLATFORM_ACTIONS', data)
    } catch (error) {
      throw error
    }
  },

  async fetchPlatformPlugins ({ commit, state, rootGetters }, action) {
    if (!action.length) {
      return
    }

    try {
      const { 'auth/platformId': platformId } = rootGetters
      const [dateStart, dateEnd] = state.pageFilter.dateRange

      commit('SET_IS_LOADING_PLATFORM_PLUGINS', true)
      commit('SET_PLATFORM_PLUGINS', [])

      const promises = action.map(action => {
        const url = `${state.mainApi}lead/plugin/${dateStart}/${dateEnd}/${platformId}/${action}`

        return axios.get(url)
      })

      const responses = await Promise.all(promises)

      let plugins: any = []

      responses.forEach((response: any) => {
        const pluginsFetched = response.data
          .filter(item => item.plugin !== null)
          .map(item => item.plugin)

        plugins = [...new Set([...plugins, ...pluginsFetched])]
      })

      commit('SET_PLATFORM_PLUGINS', plugins.sort())
    } catch (error) {
      throw error
    } finally {
      commit('SET_IS_LOADING_PLATFORM_PLUGINS', false)
    }
  },

  async fetchPlatformAttributes ({ commit, state, rootGetters }) {
    if (state.platformAttributes.length) {
      return
    }

    try {
      const { 'auth/platformId': platformId } = rootGetters
      const url = `${state.mainApi}lead/attribute/${platformId}`
      const response = await axios.get(url)

      commit('SET_PLATFORM_ATTRIBUTES', response.data)
    } catch (error) {
      throw error
    }
  },
}

export default actions
